import { render } from "./associationAdd.vue?vue&type=template&id=44fbc383&scoped=true"
import script from "./associationAdd.vue?vue&type=script&lang=js"
export * from "./associationAdd.vue?vue&type=script&lang=js"

import "./associationAdd.vue?vue&type=style&index=0&id=44fbc383&lang=scss&scoped=true"
import "./associationAdd.vue?vue&type=style&index=1&id=44fbc383&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44fbc383"]])

export default __exports__